module.exports = __webpack_public_path__ + "img/sec_tell.8df7a196.svg";